import React, { useRef, useEffect } from 'react';
import { timeline } from 'motion';
import { StyledCookieConsentHeader } from '../CookieConsent.styles';
import { StyledSvg, StyledContainer } from './CookieConsentConfirm.styles';

const draw = (progress) => ({
    // This property makes the line "draw" in when animated
    strokeDashoffset: 1 - progress,

    // Each line will be hidden until it starts drawing
    // to fix a bug in Safari where the line can be
    // partially visible even when progress is at 0
    visibility: 'visible',
});

const CookieConsentConfirm = () => {
    const cicleRef = useRef(null);
    const pathRef = useRef(null);

    useEffect(() => {
        if (cicleRef && pathRef) {
            timeline([
                ['circle', draw(1), { duration: 0.4, delay: 0.2 }],
                ['path', draw(1), { duration: 0.2, at: '-0.2' }],
            ]);
        }
    }, [cicleRef, pathRef]);

    return (
        <StyledContainer>
            <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                <circle ref={cicleRef} cx="100" cy="100" r="80" pathLength="1" />
                <path ref={pathRef} d="M 54 107.5 L 88 138.5 L 144.5 67.5" pathLength="1" />
            </StyledSvg>
            <StyledCookieConsentHeader>Ditt val har sparats</StyledCookieConsentHeader>
        </StyledContainer>
    );
};

export default CookieConsentConfirm;
